export default "__VITE_ASSET__DghGwYyS__"